const CatalogDetailGalleryItem = (filename) => {
    return `
        <div class="catalog-detail-gallery__item catalog-detail-gallery__item--preview" style="background-image: url('${filename}')"></div>
    `;
};

export default CatalogDetailGalleryItem;
